import React from 'react';
import { Trans } from '@lingui/react';

export default {
    Cancel: <Trans>Cancel</Trans>,
    Move: <Trans>Move</Trans>,
    Copy: <Trans>Copy</Trans>,
    Ok: <Trans>Ok</Trans>,
    unassignMessages: {
        unassignStudent: <Trans>Unassign Student</Trans>,
        unassignStudents: <Trans>Unassign Students</Trans>,
        student: <Trans>The selected student will be</Trans>,
        students: <Trans>The selected students will be</Trans>,
        unassigned: <Trans>unassigned</Trans>,
        andMay: <Trans>and may</Trans>,
        loseAccess: <Trans>lose access to the current product.</Trans>,
        continue: <Trans>Do you wish to continue?</Trans>
    },
    moveCopy: {
        doYou: <Trans>Do you want to</Trans>,
        or: <Trans>or</Trans>,
        move: <Trans>move</Trans>,
        copy: <Trans>copy</Trans>,
        selected: <Trans>the selected student(s)?</Trans>,
        currentClass: <Trans>- the student(s) will move from their current class(es) to the new class</Trans>,
        newClass: <Trans>- the student(s) will be in both the original and the new class</Trans>
    },
    confirm: {
        youHave: <Trans>You have</Trans>,
        moved: <Trans>moved</Trans>,
        copied: <Trans>copied</Trans>,
        Student: <Trans>Student</Trans>,
        Students: <Trans>Students</Trans>,
        have: <Trans>have</Trans>,
        has: <Trans>has</Trans>,
        beenUnassigned: <Trans>been unassigned</Trans>
    }

};



// WEBPACK FOOTER //
// ./containers/confirmation-modal/confirmation-modal-text.js